var _rect;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBtnJoinChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 23.5,
    fill: "#191A1C",
    stroke: "#4AFEBF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m 31.5832,20.75 h -4.3334 v -6.5 h -6.5 v 6.5 h -4.3333 l 7.5833,7.5833 z M 16.4165,30.5 v 2.1667 H 31.5832 V 30.5 Z",
    fill: "#4afebf",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m 16.491411,25.262932 -5.519207,-2.059864 c -0.560559,-0.209997 -0.565436,-1.001381 -0.0064,-1.217042 l 22.650853,-8.738039 c 0.480241,-0.18571 0.975741,0.234961 0.870978,0.739254 l -4.064671,19.552741 c -0.09595,0.461522 -0.637072,0.671048 -1.019157,0.393253 l -5.548812,-4.028492 c -0.337097,-0.244761 -0.796418,-0.231548 -1.118886,0.03099 l -3.076503,2.508173 c -0.357232,0.292109 -0.895203,0.129302 -1.032056,-0.31067 z m 12.578602,-7.739944 -10.78667,6.643395 c -0.41342,0.255143 -0.608017,0.754418 -0.474531,1.221918 l 1.166375,4.097863 c 0.08274,0.290378 0.504309,0.260648 0.54442,-0.03948 l 0.303121,-2.247053 c 0.05726,-0.423141 0.259075,-0.812934 0.572105,-1.104256 l 8.901852,-8.274895 c 0.166582,-0.154407 -0.03288,-0.416535 -0.226672,-0.297489 z",
    fill: "#4afebf",
    style: {
      strokeWidth: 1.57302
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnJoinChat);
export default __webpack_public_path__ + "static/media/btn-join-chat.6f45d134879e8e1c82df6271ebb34157.svg";
export { ForwardRef as ReactComponent };